import { DemoProvider } from '@/contexts/DemoContext';
import DemoOnePager from '@/components/demo/DemoOnePager';
import { SeoHead } from '@/components/SeoHead';

export default function Demo() {
  return (
    <DemoProvider>
      <SeoHead
        title="Demo — Drinks in 365 Days challenge"
        description="Try the 100 drinks in 365 days challenge in demo mode. Explore the dashboard, leaderboard, and rewards without signing up."
        path="/demo"
      />
      <DemoOnePager />
    </DemoProvider>
  );
}
